import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as helperStyles } from '../../../../assets/style-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${componentStyles}`),
  unsafeCSS(`${helperStyles}`),
  unsafeCSS(`${widgetSharedStyles}`),
];
